import { render } from "./OrderPies.vue?vue&type=template&id=21a6e850&scoped=true"
import script from "./OrderPies.vue?vue&type=script&lang=ts"
export * from "./OrderPies.vue?vue&type=script&lang=ts"

import "./OrderPies.vue?vue&type=style&index=0&id=21a6e850&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21a6e850"

export default script